import { Flex } from 'antd';
import { Card, Skeleton } from '@common-web/index';

const ReviewSkeleton = ({ count = 3 }) => {
  return (
    <Card>
      {Array.from({ length: count }).map((_, index) => (
        <Flex vertical gap={12} key={index}>
          <Flex gap={8}>
            <Skeleton height={22} width={44} />
            <Skeleton height={22} width={100} />
          </Flex>

          <Flex gap={8}>
            <Skeleton height={24} width={24} />
            <Flex vertical gap={2}>
              <Skeleton height={16} width={80} />
              <Skeleton height={18} width={100} />
            </Flex>
          </Flex>
          <Skeleton height={16} width={300} />
          <Skeleton height={22} width={400} />
          <Skeleton height={48} />
        </Flex>
      ))}
    </Card>
  );
};

export default ReviewSkeleton;
